import React from "react"
import CookieConsent from "react-cookie-consent"
import { motion } from "framer-motion"
import { useLanguageStore } from "../../state-management/languageStore"

const transition = {
    duration: 0.33,
    ease: "easeInOut",
    type: "spring",
}

export default function CookiePrompt({ onAccept, onDecline, visible }) {
    const cookieName = "profileData"
    const t = useLanguageStore((state) => state.translate)

    return (
        <motion.div
            data-disable-swipe
            initial={{ y: 100 }}
            animate={{ y: 0.1 }}
            exit={{ y: 100 }}
            transition={transition}
            className="fixed bottom-0 left-0 w-full  h-auto z-[1000]" // Nav är z-[999]
        >
            <CookieConsent
                onAccept={onAccept}
                enableDeclineButton
                onDecline={onDecline}
                cookieName={cookieName}
                buttonText={t("cookiePrompt.accept")}
                contentClasses="text-black dark:text-white mx-auto max-w-lg"
                declineButtonText={t("cookiePrompt.decline")}
                containerClasses={
                    "p-4 pb-safe space-y-4 pt-4 bg-white/75 dark:bg-neutral-900/90 backdrop-blur-sm border-t border-neutral-300 dark:border-neutral-800 "
                }
                overlayClasses="bg-red-200"
                buttonClasses={
                    "grid p-4 rounded-lg bg-gradient-to-br from-neutral-700 to-neutral-800 text-lg font-semibold text-white dark:text-black dark:from-neutral-50 dark:to-neutral-200"
                }
                declineButtonClasses={"px-4 text-primary-400 text-lg"}
                buttonWrapperClasses={
                    "w-full pb-4 max-w-lg mx-auto flex flex-col-reverse justify-between gap-2 mb-4"
                }
                visible={visible}
                disableButtonStyles={true}
                disableStyles={true}
            >
                {t("cookiePrompt.message")}
            </CookieConsent>
        </motion.div>
    )
}
